/**
 * 服务器日志工具
 * 通过发送 1x1 像素图片请求，将日志记录到 Nginx 访问日志中
 * 方便在服务器上通过 tail -f /var/log/nginx/access.log 查看前端运行状态
 *
 * Nginx 日志中可通过过滤 "__log__" 关键字查看这些日志
 */

import { API_HOST } from '../config/api'

let logSeq = 0

/**
 * 发送日志到服务器（通过图片请求，Nginx 会记录到 access.log）
 * @param {string} tag 日志标签，如 [DingTalk]、[SSO]、[Vote]
 * @param {string} msg 日志消息
 * @param {object} extra 额外数据对象
 */
export function serverLog (tag, msg, extra) {
  try {
    logSeq++
    const payload = {
      t: tag,
      m: String(msg).substring(0, 500),
      e: extra ? JSON.stringify(extra).substring(0, 800) : '',
      s: logSeq,
      ts: Date.now(),
      ua: (navigator.userAgent || '').substring(0, 200),
      url: window.location.href
    }
    // 使用 1x1 透明 gif 请求，Nginx 会记录到 access.log
    // 日志内容放在 URL 参数中，方便 grep 过滤
    const qs = Object.keys(payload).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(payload[k] || '')).join('&')
    const img = new Image()
    img.src = API_HOST + '/__log__?' + qs
  } catch (e) {
    // 日志发送失败不影响主流程
  }
}

/**
 * 快捷方法：钉钉相关日志
 */
export function logDingTalk (msg, extra) {
  console.log('[DingTalk]', msg, extra || '')
  serverLog('DingTalk', msg, extra)
}

/**
 * 快捷方法：SSO 登录相关日志
 */
export function logSSO (msg, extra) {
  console.log('[SSO]', msg, extra || '')
  serverLog('SSO', msg, extra)
}

/**
 * 快捷方法：投票相关日志
 */
export function logVote (msg, extra) {
  console.log('[Vote]', msg, extra || '')
  serverLog('Vote', msg, extra)
}

/**
 * 快捷方法：通用访问日志
 */
export function logAccess (msg, extra) {
  console.log('[Access]', msg, extra || '')
  serverLog('Access', msg, extra)
}

/**
 * 快捷方法：错误日志
 */
export function logError (msg, extra) {
  console.error('[Error]', msg, extra || '')
  serverLog('Error', msg, extra)
}

export default {
  serverLog,
  logDingTalk,
  logSSO,
  logVote,
  logAccess,
  logError
}


// WEBPACK FOOTER //
// ./src/utils/serverLog.js